import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProfilePaymethodsPageRoutingModule } from './profile-paymethods-routing.module';

import { ProfilePaymethodsPage } from './profile-paymethods.page';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ProfilePaymethodsPageRoutingModule,
    ],
    declarations: [ProfilePaymethodsPage],
})
export class ProfilePaymethodsPageModule {}
